module.exports = __webpack_public_path__ + "static/media/IMCTrading.214e1133.png";